export interface PlayerPageTranslations {
  loading: string;
  playerNotFound: string;
  currentEloRating: string;
  predictedChange: string;
  winRate: string;
  games: string;
  eloHistory: string;
  recentMatches: string;
  viewAllMatches: string;
  won: string;
  lost: string;
  swissRank: string;
  license: string;
  vsStronger: string;
  vsWeaker: string;
  bestStreak: string;
  streakDays: string;
  eloGained: string;
  performanceStats: string;
  competitions: string;
  winRateShort: string;
  totalGames: string;
  eloChange: string;
  overallWinRate: string;
  vsHigherElo: string;
  vsLowerElo: string;
  basedOnLast12Months: string;
  projected: string;
  classificationProgress: string;
  pointsTo: string;
  lastMatches: string;
  months: string;
  favoritesLimitTitle: string;
  favoritesLimitMessage: string;
  downloadApp: string;
  cancel: string;
  setStatistics: string;
  setStatsDescription: string;
  scorelines: string;
  losses: string;
  wins: string;
  dominance: string;
  dominantWins: string;
  dominantWinsExplain: string;
  cleanSheets: string;
  cleanSheetsExplain: string;
  clutch: string;
  clutchExplain: string;
  comebacks: string;
  wonAfterLosingFirst: string;
  wonAfterLosingFirstExplain: string;
  reverseSweeps: string;
  reverseSweepsExplain: string;
  firstSetAdvantage: string;
  winRateWhenWonFirst: string;
  winRateWhenWonFirstExplain: string;
  winRateWhenLostFirst: string;
  winRateWhenLostFirstExplain: string;
  avoidingSweeps: string;
  matchesWithScores: string;
  matches: string;
  unlockMoreStats: string;
  unlockMoreStatsSubtitle: string;
  homeAwayAnalysis: string;
  homeAwayAnalysisDesc: string;
  competitionTypeAnalysis: string;
  competitionTypeAnalysisDesc: string;
  aiInsights: string;
  aiInsightsDesc: string;
  detailedTrends: string;
  detailedTrendsDesc: string;
  getTheApp: string;
  wrappedTitle: string;
  wrappedSubtitle: string;
  wrappedButton: string;
}

export const playerPageTranslations: Record<'en' | 'fr' | 'de' | 'it', PlayerPageTranslations> = {
  en: {
    loading: 'Loading...',
    playerNotFound: 'Player not found',
    currentEloRating: 'Current ELO Rating',
    predictedChange: 'Predicted change from recent matches',
    winRate: 'Win Rate',
    games: 'Games',
    eloHistory: 'ELO History',
    recentMatches: 'Recent Matches',
    viewAllMatches: 'View all in app',
    won: 'Won',
    lost: 'Lost',
    swissRank: 'Swiss Rank',
    license: 'License',
    vsStronger: 'vs Stronger',
    vsWeaker: 'vs Weaker',
    bestStreak: 'Best Streak',
    streakDays: 'days',
    eloGained: 'ELO gained',
    performanceStats: 'Performance Stats',
    competitions: 'Competitions',
    winRateShort: 'win rate',
    totalGames: 'Total Games',
    eloChange: 'ELO Change',
    overallWinRate: 'Overall Win Rate',
    vsHigherElo: 'vs Higher ELO',
    vsLowerElo: 'vs Lower ELO',
    basedOnLast12Months: 'Based on last 12 months',
    projected: 'Projected',
    classificationProgress: 'Classification Progress',
    pointsTo: 'points to',
    lastMatches: 'Last 5 matches',
    months: 'months',
    favoritesLimitTitle: 'Favorites Limit Reached',
    favoritesLimitMessage: 'You can only have 3 favorites on the web. Download the app for unlimited favorites and more features!',
    downloadApp: 'Download App',
    cancel: 'Cancel',
    setStatistics: 'Set Statistics',
    setStatsDescription: 'Advanced match analysis',
    scorelines: 'Scorelines',
    losses: 'Losses',
    wins: 'Wins',
    dominance: 'Dominance',
    dominantWins: 'Dominant Wins',
    dominantWinsExplain: '3-0 or 3-1',
    cleanSheets: 'Clean Sheets',
    cleanSheetsExplain: 'Only 3-0',
    clutch: 'In Close Matches',
    clutchExplain: 'Win rate in 3-2',
    comebacks: 'Comebacks',
    wonAfterLosingFirst: 'Comebacks',
    wonAfterLosingFirstExplain: 'Won after losing set 1',
    reverseSweeps: 'Reverse Sweeps',
    reverseSweepsExplain: 'Won 3-2 after 0-2',
    firstSetAdvantage: 'First Set Advantage',
    winRateWhenWonFirst: 'Won First Set',
    winRateWhenWonFirstExplain: 'Win rate if set 1 won',
    winRateWhenLostFirst: 'Lost First Set',
    winRateWhenLostFirstExplain: 'Win rate if set 1 lost',
    avoidingSweeps: 'Avoiding Sweeps',
    matchesWithScores: 'matches with scores',
    matches: 'Matches',
    unlockMoreStats: 'More insights in the app',
    unlockMoreStatsSubtitle: 'Unlock advanced analytics',
    homeAwayAnalysis: 'Home & Away Analysis',
    homeAwayAnalysisDesc: 'Performance breakdown by venue',
    competitionTypeAnalysis: 'Competition Type Analysis',
    competitionTypeAnalysisDesc: 'Liga vs Tournament statistics',
    aiInsights: 'AI-Powered Insights',
    aiInsightsDesc: 'Mental strength & form analysis',
    detailedTrends: 'Performance Trends',
    detailedTrendsDesc: 'Weekly & monthly breakdowns',
    getTheApp: 'Get the App',
    wrappedTitle: 'Your 2025 Wrapped',
    wrappedSubtitle: 'Discover your year in table tennis',
    wrappedButton: 'View Now'
  },
  fr: {
    loading: 'Chargement...',
    playerNotFound: 'Joueur introuvable',
    currentEloRating: 'Classement ELO Actuel',
    predictedChange: 'Changement prédit des matchs récents',
    winRate: 'Taux de Victoire',
    games: 'Matchs',
    eloHistory: 'Historique ELO',
    recentMatches: 'Matchs Récents',
    viewAllMatches: 'Tout voir dans l\'app',
    won: 'Gagné',
    lost: 'Perdu',
    swissRank: 'Rang Suisse',
    license: 'Licence',
    vsStronger: 'vs Plus Fort',
    vsWeaker: 'vs Plus Faible',
    bestStreak: 'Meilleure Série',
    streakDays: 'jours',
    eloGained: 'ELO gagné',
    performanceStats: 'Statistiques de Performance',
    competitions: 'Compétitions',
    winRateShort: 'taux de victoire',
    totalGames: 'Total des Matchs',
    eloChange: 'Changement ELO',
    overallWinRate: 'Taux de Victoire Global',
    vsHigherElo: 'vs ELO Supérieur',
    vsLowerElo: 'vs ELO Inférieur',
    basedOnLast12Months: 'Basé sur les 12 derniers mois',
    projected: 'Projeté',
    classificationProgress: 'Progrès de Classification',
    pointsTo: 'points pour',
    lastMatches: 'Les 5 derniers matchs',
    months: 'mois',
    favoritesLimitTitle: 'Limite de Favoris Atteinte',
    favoritesLimitMessage: 'Tu ne peux avoir que 3 favoris sur le web. Télécharge l\'appli pour des favoris illimités et plus de fonctionnalités !',
    downloadApp: 'Télécharger l\'Appli',
    cancel: 'Annuler',
    setStatistics: 'Statistiques de Sets',
    setStatsDescription: 'Analyse avancée des matchs',
    scorelines: 'Scores',
    losses: 'Défaites',
    wins: 'Victoires',
    dominance: 'Dominance',
    dominantWins: 'Victoires Dominantes',
    dominantWinsExplain: '3-0 ou 3-1',
    cleanSheets: 'Victoires Nettes',
    cleanSheetsExplain: 'Uniquement 3-0',
    clutch: 'Dans les Moments Décisifs',
    clutchExplain: 'Taux victoire en 3-2',
    comebacks: 'Remontées',
    wonAfterLosingFirst: 'Remontées',
    wonAfterLosingFirstExplain: 'Gagné après set 1 perdu',
    reverseSweeps: 'Retour Complet',
    reverseSweepsExplain: 'Gagné 3-2 après 0-2',
    firstSetAdvantage: 'Avantage Premier Set',
    winRateWhenWonFirst: 'Premier Set Gagné',
    winRateWhenWonFirstExplain: 'Taux victoire si set 1 gagné',
    winRateWhenLostFirst: 'Premier Set Perdu',
    winRateWhenLostFirstExplain: 'Taux victoire si set 1 perdu',
    avoidingSweeps: 'Éviter les Balayages',
    matchesWithScores: 'matchs avec scores',
    matches: 'Matchs',
    unlockMoreStats: 'Plus d\'analyses dans l\'app',
    unlockMoreStatsSubtitle: 'Débloquez des analyses avancées',
    homeAwayAnalysis: 'Analyse Domicile & Extérieur',
    homeAwayAnalysisDesc: 'Performance par lieu',
    competitionTypeAnalysis: 'Analyse Type de Compétition',
    competitionTypeAnalysisDesc: 'Statistiques Ligue vs Tournoi',
    aiInsights: 'Analyses IA',
    aiInsightsDesc: 'Force mentale & analyse de forme',
    detailedTrends: 'Tendances de Performance',
    detailedTrendsDesc: 'Analyses hebdomadaires & mensuelles',
    getTheApp: 'Télécharger l\'App',
    wrappedTitle: 'Ton Wrapped 2025',
    wrappedSubtitle: 'Découvre ton année de tennis de table',
    wrappedButton: 'Voir Maintenant'
  },
  de: {
    loading: 'Lädt...',
    playerNotFound: 'Spieler nicht gefunden',
    currentEloRating: 'Aktuelle ELO-Wertung',
    predictedChange: 'Vorhergesagte Änderung aus aktuellen Spielen',
    winRate: 'Gewinnrate',
    games: 'Spiele',
    eloHistory: 'ELO-Verlauf',
    recentMatches: 'Letzte Spiele',
    viewAllMatches: 'Alles in der App anzeigen',
    won: 'Gewonnen',
    lost: 'Verloren',
    swissRank: 'Schweizer Rang',
    license: 'Lizenz',
    vsStronger: 'gegen Stärkere',
    vsWeaker: 'gegen Schwächere',
    bestStreak: 'Beste Serie',
    streakDays: 'Tage',
    eloGained: 'ELO gewonnen',
    performanceStats: 'Leistungsstatistiken',
    competitions: 'Wettbewerbe',
    winRateShort: 'Gewinnrate',
    totalGames: 'Gesamtspiele',
    eloChange: 'ELO-Änderung',
    overallWinRate: 'Gesamtgewinnrate',
    vsHigherElo: 'vs Höheres ELO',
    vsLowerElo: 'vs Niedrigeres ELO',
    basedOnLast12Months: 'Basierend auf den letzten 12 Monaten',
    projected: 'Voraussichtlich',
    classificationProgress: 'Klassifikationsfortschritt',
    pointsTo: 'Punkte bis',
    lastMatches: 'Letzte 5 Spiele',
    months: 'Monate',
    favoritesLimitTitle: 'Favoriten-Limit Erreicht',
    favoritesLimitMessage: 'Du kannst nur 3 Favoriten im Web haben. Lade die App herunter für unbegrenzte Favoriten und mehr Funktionen!',
    downloadApp: 'App Herunterladen',
    cancel: 'Abbrechen',
    setStatistics: 'Satz-Statistiken',
    setStatsDescription: 'Erweiterte Spielanalyse',
    scorelines: 'Ergebnisse',
    losses: 'Niederlagen',
    wins: 'Siege',
    dominance: 'Dominanz',
    dominantWins: 'Dominante Siege',
    dominantWinsExplain: '3-0 oder 3-1',
    cleanSheets: 'Zu-Null-Siege',
    cleanSheetsExplain: 'Nur 3-0',
    clutch: 'In Engen Spielen',
    clutchExplain: 'Gewinnrate bei 3-2',
    comebacks: 'Aufholungen',
    wonAfterLosingFirst: 'Aufholungen',
    wonAfterLosingFirstExplain: 'Gewonnen nach Satz 1 Verlust',
    reverseSweeps: 'Komplette Wende',
    reverseSweepsExplain: '3-2 gewonnen nach 0-2',
    firstSetAdvantage: 'Erster-Satz-Vorteil',
    winRateWhenWonFirst: 'Erster Satz Gewonnen',
    winRateWhenWonFirstExplain: 'Gewinnrate wenn Satz 1 gewonnen',
    winRateWhenLostFirst: 'Erster Satz Verloren',
    winRateWhenLostFirstExplain: 'Gewinnrate wenn Satz 1 verloren',
    avoidingSweeps: 'Vermeidung von Durchgängen',
    matchesWithScores: 'Spiele mit Ergebnissen',
    matches: 'Spiele',
    unlockMoreStats: 'Mehr Analysen in der App',
    unlockMoreStatsSubtitle: 'Erweiterte Analysen freischalten',
    homeAwayAnalysis: 'Heim & Auswärts Analyse',
    homeAwayAnalysisDesc: 'Leistung nach Spielort',
    competitionTypeAnalysis: 'Wettkampfart Analyse',
    competitionTypeAnalysisDesc: 'Liga vs Turnier Statistiken',
    aiInsights: 'KI-gestützte Einblicke',
    aiInsightsDesc: 'Mentale Stärke & Formanalyse',
    detailedTrends: 'Leistungstrends',
    detailedTrendsDesc: 'Wöchentliche & monatliche Analysen',
    getTheApp: 'App Herunterladen',
    wrappedTitle: 'Dein Wrapped 2025',
    wrappedSubtitle: 'Entdecke dein Tischtennis-Jahr',
    wrappedButton: 'Jetzt Ansehen'
  },
  it: {
    loading: 'Caricamento...',
    playerNotFound: 'Giocatore non trovato',
    currentEloRating: 'Rating ELO Attuale',
    predictedChange: 'Cambiamento previsto dalle partite recenti',
    winRate: 'Tasso di Vittoria',
    games: 'Partite',
    eloHistory: 'Storia ELO',
    recentMatches: 'Partite Recenti',
    viewAllMatches: 'Vedi tutto nell\'app',
    won: 'Vinta',
    lost: 'Persa',
    swissRank: 'Classifica Svizzera',
    license: 'Licenza',
    vsStronger: 'vs Più Forti',
    vsWeaker: 'vs Più Deboli',
    bestStreak: 'Miglior Serie',
    streakDays: 'giorni',
    eloGained: 'ELO guadagnato',
    performanceStats: 'Statistiche di Prestazione',
    competitions: 'Competizioni',
    winRateShort: 'tasso vittoria',
    totalGames: 'Partite Totali',
    eloChange: 'Variazione ELO',
    overallWinRate: 'Tasso di Vittoria Complessivo',
    vsHigherElo: 'vs ELO Superiore',
    vsLowerElo: 'vs ELO Inferiore',
    basedOnLast12Months: 'Basato sugli ultimi 12 mesi',
    projected: 'Previsto',
    classificationProgress: 'Progresso di Classificazione',
    pointsTo: 'punti per',
    lastMatches: 'Ultime 5 partite',
    months: 'mesi',
    favoritesLimitTitle: 'Limite Preferiti Raggiunto',
    favoritesLimitMessage: 'Puoi avere solo 3 preferiti sul web. Scarica l\'app per preferiti illimitati e più funzionalità!',
    downloadApp: 'Scarica l\'App',
    cancel: 'Annulla',
    setStatistics: 'Statistiche Set',
    setStatsDescription: 'Analisi avanzata delle partite',
    scorelines: 'Punteggi',
    losses: 'Sconfitte',
    wins: 'Vittorie',
    dominance: 'Dominanza',
    dominantWins: 'Vittorie Dominanti',
    dominantWinsExplain: '3-0 o 3-1',
    cleanSheets: 'Vittorie Nette',
    cleanSheetsExplain: 'Solo 3-0',
    clutch: 'In Partite Serrate',
    clutchExplain: 'Tasso vittoria in 3-2',
    comebacks: 'Rimonte',
    wonAfterLosingFirst: 'Rimonte',
    wonAfterLosingFirstExplain: 'Vinto dopo set 1 perso',
    reverseSweeps: 'Rimonte Complete',
    reverseSweepsExplain: 'Vinto 3-2 dopo 0-2',
    firstSetAdvantage: 'Vantaggio Primo Set',
    winRateWhenWonFirst: 'Primo Set Vinto',
    winRateWhenWonFirstExplain: 'Tasso vittoria se set 1 vinto',
    winRateWhenLostFirst: 'Primo Set Perso',
    winRateWhenLostFirstExplain: 'Tasso vittoria se set 1 perso',
    avoidingSweeps: 'Evitare le Spazzate',
    matchesWithScores: 'partite con punteggi',
    matches: 'Partite',
    unlockMoreStats: 'Più analisi nell\'app',
    unlockMoreStatsSubtitle: 'Sblocca analisi avanzate',
    homeAwayAnalysis: 'Analisi Casa & Trasferta',
    homeAwayAnalysisDesc: 'Performance per luogo',
    competitionTypeAnalysis: 'Analisi Tipo di Competizione',
    competitionTypeAnalysisDesc: 'Statistiche Campionato vs Torneo',
    aiInsights: 'Analisi AI',
    aiInsightsDesc: 'Forza mentale & analisi forma',
    detailedTrends: 'Tendenze di Performance',
    detailedTrendsDesc: 'Analisi settimanali & mensili',
    getTheApp: 'Scarica l\'App',
    wrappedTitle: 'Il Tuo Wrapped 2025',
    wrappedSubtitle: 'Scopri il tuo anno nel ping pong',
    wrappedButton: 'Guarda Ora'
  }
};
